import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwLoader } from '@spaces-ui/meadow/components/loader';

@Component({
  selector: 'mdw-dialog-footer',
  imports: [MdwButton, MdwLoader],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.scss',
})
export class MdwDialogFooter {
  public primaryButton = input<string>();
  public primaryButtonIcon = input<string>();
  public secondaryButton = input<string>();
  public secondaryButtonIcon = input<string>();
  public tertiaryButton = input<string>();
  public tertiaryButtonIcon = input<string>();
  public dangerButton = input<string>();
  public dangerButtonIcon = input<string>();
  public primaryButtonDisabled = input(false);
  public primaryButtonLoading = input(false);
  public secondaryButtonDisabled = input(false);
  public tertiaryButtonDisabled = input(false);
  public dangerButtonDisabled = input(false);
  public showSecondaryButton = input(false);

  public primaryButtonClicked = output();
  public secondaryButtonClicked = output();
  public tertiaryButtonClicked = output();
  public dangerButtonClicked = output();
}
